var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-source-form',{attrs:{"columns":_vm.columns,"data":_vm.data},on:{"submit":_vm.handleCreate}})}
var staticRenderFns = []

export { render, staticRenderFns }